import { Shape } from "@/validations/constants/shape";
import * as yup from "yup";
import { IMailingForm } from "../components/mailingListForm";

const stringSchema = yup.string();

export const getMailingFormSchema = () =>
  yup.object().shape<Shape<IMailingForm>>({
    name: stringSchema.required("Please enter your name"),
    email: stringSchema
      .trim()
      .required("Please enter your email")
      .email("Please enter a valid email"),
  });
